/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Manual_TitleInputs */

const vi_carrier_manual_title = /** @type {(inputs: Carrier_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ chưa khớp đơn vị hành chính của hãng`)
};

/**

* @param {Carrier_Manual_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_manual_title = /** @type {((inputs?: Carrier_Manual_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Manual_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_manual_title(inputs)
});